window.strapiServerUrl = 'https://www.rennamobile.com/api';
window.googleAppLink = 'https://play.google.com/store/apps/details?id=com.renna.om';
window.appleAppLink ='https://apps.apple.com/om/app/my-renna/id1240232590';